import { get } from "@ember/object"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookEditTemplates } from "@shared/models/analytics/planbook"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import Patch from "@shared/models/patch-updater"
import type { Narrative } from "../create-narrative"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

export const PLANBOOK_DELETE_TEMPLATE = {
  name: "PLANBOOK_DELETE_TEMPLATE",

  params: {
    cardStackId: "string",
    planbookId: "string",
  },

  patches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).pull(
      "relationships.cardStackTemplates.data",
      {
        id: payload.cardStackId,
        type: "card-stack",
      }
    ).patch

    return [patch]
  },

  undoPatches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).push(
      "relationships.cardStackTemplates.data",
      {
        id: payload.cardStackId,
        type: "card-stack",
      }
    ).patch

    return [patch]
  },

  narrative(payload, findFn, userId): Narrative {
    let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)
    let planbook = get(models, "planbook")
    let planbookTitle = get(get(planbook, "attributes"), "title")
    let template =
      findFn("card-stack", payload.cardStackId) || findFn("card-stack-summary", payload.cardStackId)
    let templateTitle = get(template, "attributes.title")
    let newEvent: PlanbookEditTemplates = {
      ...createBlankEvent(),
      root_id: payload.planbookId,
      root_type: "planbook",
      primary_object_id_and_ancestor_ids: [payload.planbookId],
      primary_verb: "edit",
      primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbookId),
      primary_object_type: "planbook",
      primary_object_specifier: "templates",
      adverbial_verb: "removing",
      adverbial_object_type: "template",
    }

    return {
      title: "Deleted a template",
      titleForAnalytics: "Planbook - Delete Template",
      description: `Removed the "${templateTitle}" template from your ${planbookTitle} planbook`,
      context: defaultPlanbookContext(payload, models),
      activity: defaultPlanbookActivity(payload, models),
      newAnalyticsEvents: [newEvent],
    }
  },
}
